import { render } from "./ChangeLanguage.vue?vue&type=template&id=bb67d5ac&scoped=true"
import script from "./ChangeLanguage.vue?vue&type=script&lang=js"
export * from "./ChangeLanguage.vue?vue&type=script&lang=js"

import "./ChangeLanguage.vue?vue&type=style&index=0&id=bb67d5ac&scoped=true&lang=css"

import exportComponent from "D:\\JOSE\\Escritorio\\Proyectos VUE\\canal-denuncias\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb67d5ac"]])

export default __exports__